<template>
  <div class="navigation">
    <nav class="navbar navbar-expand-md navbar-light">
      <router-link to="/" class="navbar-brand" ><img class="logo-img" src="../assets/images/logo.png"></router-link>
      <button  v-if="loguead != 0" v-on:click="openNav" ref="" class="navbar-toggler btn-mobile-access" type="button" data-toggle="" data-target="">
        <span v-if="loguead != 0" class="navbar-toggler-icon"></span>
      </button>
      <button v-if="loguead == 0" v-on:click="openNav" class="navbar-toggler btn-mobile-access" type="button" data-toggle="" data-target="">
        <span >{{ $t('nav.login_acceso') }} <img src="../assets/images/access.png"> </span>
      </button>
      <div v-if="loguead == 0" class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav mr-auto"></ul>
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" v-scroll-to="'#about'" href="#">{{ $t('nav.about') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" v-scroll-to="'#value'" href="#">{{ $t('nav.projection') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" v-scroll-to="'#contact'" href="#">{{ $t('nav.contact') }}</a>
          </li>
          <li class="nav-item">
            <a v-on:click="openNav" class="nav-link" href="#">{{ $t('nav.login') }}</a>
          </li>
        </ul>
        
        <ul class="navbar-nav">
          <li v-for="(o, i) in LOCALES" :key="i" :value="o.value" :selected="o.value === defaultLocale">
            <button v-on:click="setLenguaje(o.value)" >{{ o.caption }}</button>
          </li>
        </ul>
      </div>

      <div v-if="loguead == 1" class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav mr-auto"></ul>
          <ul class="navbar-nav">
              <li class="nav-item to-pa">
                <router-link to = "/feed">{{ $t('navUser.players')}}</router-link>
              </li>
              <li class="nav-item to-pa">
                <router-link to = "/profile">{{ $t('navUser.profile')}}</router-link>
              </li>
              <li class="nav-item to-pa">
                <button v-on:click="logOut" >{{ $t('navUser.close')}}</button>
              </li>
          </ul>
          <ul class="navbar-nav">
            <li v-for="(o, i) in LOCALES" :key="i" :value="o.value" :selected="o.value === defaultLocale">
              <button v-on:click="setLenguaje(o.value)" >{{ o.caption }}</button>
            </li>
          </ul>
      </div>
      <div v-if="loguead == 2" class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav mr-auto"></ul>
          <ul class="navbar-nav">
            
            <li class="nav-item to-pa">
              <router-link to = "/admin">{{ $t('navAdmin.users')}}</router-link>
            </li>
            <li class="nav-item to-pa">
              <router-link to = "/players">{{ $t('navUser.players')}}</router-link>
            </li>
            <li class="nav-item to-pa">
              <router-link to = "/buzon">{{ $t('navAdmin.inbox')}}</router-link>
            </li>
            <li class="nav-item to-pa">
              <router-link to = "/slideshow">Slideshow</router-link>
            </li>
            <li class="nav-item to-pa">
              <button v-on:click="logOut" >{{ $t('navUser.close')}}</button>
            </li>
          </ul>
          <ul class="navbar-nav">
            <li v-for="(o, i) in LOCALES" :key="i" :value="o.value" :selected="o.value === defaultLocale">
              <button v-on:click="setLenguaje(o.value)" >{{ o.caption }}</button>
            </li>
          </ul>
      </div>
    </nav>

    <!-- The overlay -->
    <div id="myNav" class="overlay">

      <!-- Overlay content -->     
      <div class="container info-c">
        <a href="javascript:void(0)" class="closebtn" v-on:click="closeNav">&times;</a>
        <!-- Button to close the overlay navigation -->
        <div v-if="loguead == 0" class="overlay-content info">
          <h1>{{ $t('login.welcome') }}</h1>
          <p>{{ $t('login.instructions') }}</p>

          <div class="con-i f-init">
            <input type="text" v-model="email" name="correo" :placeholder=" $t('login.form_email')" /><br>
            <input type="password" v-model="pass" name="pass" :placeholder=" $t('login.form_pass')" /><br><br>
            <p class="error" v-if="error != ''">{{error}}</p><button v-on:click="closeSessionStart" v-if="code == 141" class="button_code_error">{{this.$t('login.errorSesionContinue')}}</button>
            <br>
            <button v-on:click="login" class="btn send-b">{{ $t('login.log_in')}}</button><br>
          </div>
        </div>  
        <div v-if="loguead == 1" class="overlay-content info">
          <ul class="navbar-nav img-movil">
              <li class="nav-item to-pa">
                <router-link to = "/feed"><img src="../assets/images/icon_players.png"> {{ $t('navUser.players')}}</router-link>
              </li>
              <li class="nav-item to-pa">
                <router-link to = "/profile"> <img src="../assets/images/icon_profile.png"> {{ $t('navUser.profile')}} </router-link>
              </li>
              <li class="nav-item to-pa">
                <button v-on:click="logOut" ><img src="../assets/images/icon_logout.png"> {{ $t('navUser.close')}} </button>
              </li>
          </ul>
          <ul class="navbar-nav idiom">
            <li v-for="(o, i) in LOCALES" :key="i" :value="o.value" :selected="o.value === defaultLocale">
              <button v-on:click="setLenguaje(o.value)" class="send-b-movil" >{{ o.caption }}</button>
            </li>
          </ul>
        </div>
        <div v-if="loguead == 2" class="overlay-content info">
          <ul class="navbar-nav img-movil">
             
              <li class="nav-item to-pa">
                <router-link to = "/usuarios"> <img src="../assets/images/icon_profile.png">{{ $t('navAdmin.users')}}</router-link>
              </li>
              <li class="nav-item to-pa">
                <router-link to = "/players"><img src="../assets/images/icon_players.png">{{ $t('navUser.players')}}</router-link>
              </li>
              <li class="nav-item to-pa">
                <router-link to = "/buzon"><img src="../assets/images/icon_players.png">{{ $t('navAdmin.inbox')}}</router-link>
              </li>
               <li class="nav-item to-pa">
                <router-link to = "/slideshow"><img src="../assets/images/icon_slideshow.png">Slideshow</router-link>
              </li>
              <li class="nav-item to-pa">
                <button v-on:click="logOut" ><img src="../assets/images/icon_logout.png"> {{ $t('navUser.close')}}</button>
              </li>
          </ul>
          <ul class="navbar-nav idiom">
            <li v-for="(o, i) in LOCALES" :key="i" :value="o.value" :selected="o.value === defaultLocale">
              <button v-on:click="setLenguaje(o.value)" class="send-b-movil" >{{ o.caption }}</button>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import { bus } from "../main";
import User from '../parse/models/User'
import { LOCALES } from "@/lang/locales";
import { defaultLocale } from "@/lang";

export default {
  
  params: ['isFocused'],
  name: 'navigation',
  data(){
    return{
      errorLogin: "",
      errorLogin2: "",
      email: "",
      pass: "",
      error: "",
      loguead: null,
      LOCALES, 
      defaultLocale,
      roleAdmin: "mzLfUNRL46",
      roleUser: "6Wk2ojqf4D",
      code: 0
    }
  },
  beforeMount() {
    this.loguead = localStorage.login;
  },
  watch: {
    isFocused(val){
      if (val === true) {
        this.$refs.about.focus() 
      }
    }
  },
  methods: {
    login(){

      const user = new this.$parse.User();

      //console.log(user)
      user.setUsername(this.email);
      user.setPassword(this.pass);
      
      //const params = {
        //username: this.email,
        //password: this.pass
      //}

      /*user.logIn()
      //User.logIn(params)
        .then((res) => {
          console.log(res)
          if( res.attributes.role.id == this.roleAdmin){
            this.$router.push('/admin')
          }else if( res.attributes.role.id == this.roleUser){
            this.$router.push('/feed')
          } else {
            this.error = "Usuario no registrado"
          }
        })
        .catch((error) => {
          console.log(error.code)
          if(error.code == 200){
            this.error = this.$t('login.errorClean')
            setTimeout(() => (this.cleanForm), 3000);
          }

          if(error.code == 101){
            this.error = this.$t('login.error')
            setTimeout(() => (this.cleanForm), 3000);

          }
      });*/
      user.logIn()
      //User.logIn(params)
        .then((res) => {
          
          console.log(res)
          localStorage.token = res.attributes.sessionToken

          if( res.attributes.role.id == this.roleAdmin){
            this.$router.push('/admin')
          }else if( res.attributes.role.id == this.roleUser){
            this.$router.push('/feed')
          } else {
            this.error = "Usuario no registrado"
          }

          if(res.code == 101){
            this.error = this.$t('login.errorClean')
            setTimeout(() => (this.cleanForm), 3000);
            return
          }

          if(res.code == 200){
            this.error = this.$t('login.error')
            setTimeout(() => (this.cleanForm), 3000);
            return
          }

          /*if(res.code == 210){
            
            if(localStorage.token){

            this.$parse.User.become(localStorage.token)
              .then((res) => {
                
                if(res.attributes.role.id == this.roleAdmin){
                  this.$router.push('/admin')
                } else if ( res.attributes.role.id == this.roleUser){
                  this.$router.push('/feed')
                } else {
                  this.error = "Usuario no registrado"
                }
              })
              .catch((error) => {
                console.log(error)
              });
            } else {

              this.code = res.code;
              this.error = this.$t('login.errorSesion')
            }
            return
          }*/

          /*localStorage.token = res.sessionToken
          localStorage.objectId = res.objectId

          if(res.user.role.id == this.roleAdmin){
            this.$router.push('/admin')
          }else if( res.user.role.id == this.roleUser){
            this.$router.push('/feed')
          } else {
            this.error = "Usuario no registrado"
          }*/
        })
        .catch((error) => {
          
          

          if(error.code == 141){

            this.code = error.code;

            this.error = this.$t('login.errorSesion')
            setTimeout(() => (this.cleanForm), 3000);
          }

          if(error.code == 200){
            this.error = this.$t('login.errorClean')
            setTimeout(() => (this.cleanForm), 3000);
          }

          if(error.code == 101){
            this.error = this.$t('login.error')
            setTimeout(() => (this.cleanForm), 3000);
          }
      });
    },
    closeSessionStart(){
      
      //--Prod 
      localStorage.removeItem('Parse/84bc7023-7559-4723-b998-1f2c4880ca58/currentUser');
      //--Dev localStorage.removeItem('Parse/42fd9c1b-9de3-4bf0-8e1e-7d7bb1e1576c/currentUser');

      const user = this.$parse.User.current()      
      const params = {
        username: this.email
      }

      User.closeSession(params)
        .then((res) => {
          if(res.code == 0){
            this.login()
          }
        })
        .catch((error) => {
          console.log("In error: " + error)
      });
    },
    openNav(){
      document.getElementById("myNav").style.width = "100%";
    },
    closeNav(){
      document.getElementById("myNav").style.width = "0%";
    },
    sectionTo(){
      this.$refs.about.focus()
    },
    setLenguaje(val){
      localStorage.idiom = val
      this.$i18n.locale = val
      bus.$emit('change_array', val)
    },
    logOut(){
      localStorage.objectId = ''
      localStorage.token = ''
      const user = this.$parse.User.logOut()
      if (user) {
        this.$router.push('/')
      }
    },
    cleanForm(){
      this.email = ""
      this.pass = ""
      this.error = ""
    }
  }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.button_code_error{
  background: transparent;
  border: 0;
  font-family: "plain medium", arial;
  color: red;
  font-size: 10px !important;
  font-style: italic;
}

.navbar-nav button{
  background: #fff;
  border: 0;
}

.navbar-nav button:hover{
  text-decoration: underline;
}

.logo-img{
  max-width: 100%;
  height: 43px;
}

.to-pa {
  padding-top: 0px;
  padding-right: 40px;
}

.to-pa a{
  color: #000;
}

.navigation{
  border-bottom: 1px solid #000;
}

.f-init input{
  background: transparent;
  color: #fff;
  border: 0;
  border-bottom: 1px solid #fff;
  margin-top: 20px;
  width: 35%;
  font-size: 12px;
  padding-bottom: 10px;
}

input::placeholder {
  color: #fff;
}

::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #fff;
}
::-moz-placeholder { /* Firefox 19+ */
  color: #fff;
}
:-ms-input-placeholder { /* IE 10+ */
  color: #fff;
}
:-moz-placeholder { /* Firefox 18- */
  color: #fff;
}


.con-i{
  padding-top: 5%;
}

.send-b{
  font-size: 12px;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 0;
  width: 120px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.info{
  text-align: left;
  color: #fff;
}

.info h1{
  font-size: 25px;
  font-family: 'plain regular', arial
}

.info p{
  font-size: 18px;
}

.navbar-brand{
  font-size: 20px;
  font-weight: bold;
}
.navbar{
  padding: 1.5rem 1rem;
  font-size: 13px;
  z-index: 2;
}

.search{
  width: 30px;
  height: 30px;
  background: url('../assets/images/search.png');
  background-repeat: no-repeat;
  background-position: center; 
  background-size: 20px 20px;
  padding: 10px;
  border: none;
  margin-top: 5px;
}

.navbar-light .navbar-nav .nav-link{
  color: #000;
}

.info-c{
  position: relative;
  height: 100%;
}

/* The Overlay (background) */
.overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */   
  height: 100%;
  width: 0;
  position: fixed; /* Stay in place */
  left: 0;
  top: 0;
  background-color: rgb(0,0,0); /* Black fallback color */
  background-color: rgba(0,0,0, 0.9); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
  z-index: 30;
  display: flex;
  align-items: center;
}

/* Position the content inside the overlay */
.overlay-content {
  position: relative;
  top: 25%; /* 25% from the top */
  width: 100%; /* 100% width */
  text-align: left; /* Centered text/links */
  margin-top: 60px; /* 30px top margin to avoid conflict with the close button on smaller screens */
  padding: 20px;
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover, .overlay a:focus {
  color: #f1f1f1;
}

/* Position the close button (top right corner) */
.overlay .closebtn {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 120px;
  font-size: 16px;
  border-radius: 20px;
  border: 1px solid #fff;
  height: 30px;
  width: 30px;
  padding: 0;
  color: #fff;
  margin-right: 15px;
}

.ctrl-action{
  margin-top: 10px;
  color: #fff;
  font-size: 10px;
  font-family: 'plain regular', arial;
  text-decoration: none;
  font-weight: 600;
}

.ctrl-action img{
  width: 25px;
  margin-top: -3px;
  padding-left: 5px;
}

.error{
  color: red;
  font-size: 10px !important;
  padding-top: 20px;
  display: inline;

}

.btn-mobile-access{
  border: none;
  font-size: 14px;
  color: #000;
}

.btn-mobile-access img{
  width: 20px;
}

.navbar-brand{
  margin-right: 0;
  width: 182px;
}

.img-movil li{
  margin-top: 10px;
}
.img-movil img{
  width: 20px;
  margin-right: 5px;

}


.idiom{
  margin-top: 20px;
}
.idiom li{
  margin-top: 10px;
}

.send-b-movil{
  background: transparent;
  border: 0;
  color: #fff;
}


/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {}

/* Larger than desktop */
@media (max-width: 1000px) {
  .to-pa{
    padding-right: 20px;
  }
}

/* Larger than tablet */
@media (max-width: 767px) {

  .navbar-nav button{
    padding: 0;
    color: #fff;
  }


  .to-pa {
    padding-top: 10px;
  }

  .to-pa a{
    color: #fff;
  }


  .carousel-control-prev{
    display: none;
  }

  .carousel-control-next{
    display: none;
  }

  .f-init input{
    width: 100%;
  }

  .closebtn {
    margin-top: 30px !important;
  }

  .overlay-content {
    top: 5%;
  }

  .navbar-nav button{
    background: transparent;
    border: 0;
  }
  
}

/* Larger than phablet */
@media (max-width: 550px) {
  .overlay a {font-size: 17px}
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 5px;
  }
  .overlay .closebtn {
    font-size: 16px;
    }
}

/* Larger than mobile */
@media (max-width: 400px) {}






</style>
